import { renderLucideIcon } from '../utils/lucide-icons.js'
import { renderPopin } from './popin-renderer.js'

function normalizeEmailAdaptiveEstimateUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.ui || result.emailAdaptiveEstimateUi || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'email-adaptive-estimate') return null

  var tokenEstimate = ui.tokenEstimate && typeof ui.tokenEstimate === 'object' ? ui.tokenEstimate : {}
  var preview = ui.preview && typeof ui.preview === 'object' ? ui.preview : {}
  var recipientManager = normalizeRecipientManager(ui.recipientManager)
  var confirmAction = ui.confirmAction && typeof ui.confirmAction === 'object' ? ui.confirmAction : {}
  var cancelAction = ui.cancelAction && typeof ui.cancelAction === 'object' ? ui.cancelAction : {}

  return {
    type: 'email-adaptive-estimate',
    title: String(ui.title || 'Estimation génération adaptative'),
    message: String(ui.message || '').trim(),
    count: normalizeCount(ui.count),
    generatedLabel: String(ui.generatedLabel || 'Emails générés'),
    generatedCount: normalizeCount(ui.generatedCount),
    totalCount: normalizeCount(ui.totalCount || ui.count),
    tokenEstimate: {
      estimatedTotalTokens: normalizeCount(tokenEstimate.estimatedTotalTokens),
      estimatedCredits: normalizeNullableAmount(tokenEstimate.estimatedCredits),
      sampleTokens: normalizeCount(tokenEstimate.sampleTokens),
      estimatedThousands: Number(tokenEstimate.estimatedThousands) || 0,
      availableCredits: normalizeNullableAmount(tokenEstimate.availableCredits),
      availableTokens: tokenEstimate.availableTokens === null || tokenEstimate.availableTokens === undefined ? null : normalizeCount(tokenEstimate.availableTokens),
      canGenerate: tokenEstimate.canGenerate !== false,
      level: String(tokenEstimate.level || 'info').toLowerCase() === 'warning' ? 'warning' : 'info',
      label: String(tokenEstimate.label || 'Coût estimé'),
      message: String(tokenEstimate.message || '').trim()
    },
    previewLabel: String(ui.previewLabel || 'Premier email généré'),
    preview: {
      to: String(preview.to || ''),
      subject: String(preview.subject || ''),
      body: String(preview.body || '')
    },
    recipientManager: recipientManager,
    confirmAction: {
      label: String(confirmAction.label || 'Générer tous les emails'),
      enabled: confirmAction.enabled !== false,
      estimateId: String(confirmAction.estimateId || '').trim()
    },
    cancelAction: {
      label: String(cancelAction.label || 'Modifier les consignes'),
      target: String(cancelAction.target || 'EMailDefine').trim() || 'EMailDefine'
    }
  }
}

function renderEmailAdaptiveEstimateUi(ui) {
  var tokenClass = ui.tokenEstimate.level === 'warning' ? ' warning' : ''
  var available = ui.tokenEstimate.availableCredits === null
    ? ''
    : '<div class="wc-email-adaptive-kpi"><span>Crédits disponibles</span><strong>' + escapeHtml(formatCredits(ui.tokenEstimate.availableCredits)) + '</strong></div>'
  var estimated = ui.tokenEstimate.estimatedCredits === null
    ? 'Indisponible'
    : formatCredits(ui.tokenEstimate.estimatedCredits)

  return (
    '<div class="wc-email-adaptive-ui">' +
      '<div class="wc-ds-capability wc-ds-capability-plume">' +
        '<div class="wc-ds-capability-name">' + renderLucideIcon('feather') + '<span>@Plume</span></div>' +
        '<div class="wc-ds-capability-meta">' + escapeHtml(ui.title) + '</div>' +
      '</div>' +
      '<section class="wc-email-generate-token' + tokenClass + '">' +
        renderLucideIcon(ui.tokenEstimate.canGenerate ? 'badgeInfo' : 'triangleAlert') +
        '<div class="wc-email-generate-token-copy">' +
          '<div class="wc-email-generate-token-message"><strong>' + escapeHtml(ui.tokenEstimate.label) + '</strong><span>' + escapeHtml(ui.tokenEstimate.message || ui.message) + '</span></div>' +
        '</div>' +
      '</section>' +
      '<div class="wc-email-adaptive-kpis">' +
        '<button type="button" class="wc-email-adaptive-kpi wc-email-adaptive-recipient-kpi" data-email-adaptive-recipients="true">' +
          '<span>' + escapeHtml(ui.recipientManager.label || 'Destinataires') + '</span>' +
          '<strong>' + escapeHtml(formatInteger(ui.count)) + '</strong>' +
          '<small>' + escapeHtml(ui.recipientManager.hint || 'Cliquer pour consulter et/ou écarter des destinataires') + '</small>' +
        '</button>' +
        '<div class="wc-email-adaptive-kpi"><span>Coût estimé</span><strong>' + escapeHtml(estimated) + ' crédits</strong></div>' +
        available +
      '</div>' +
      '<div class="wc-email-adaptive-recipient-popin-host" data-email-adaptive-recipient-popin-host hidden>' + renderRecipientPopin(ui) + '</div>' +
      '<section class="wc-email-adaptive-progress">' +
        '<div class="wc-email-generate-section-label">' + escapeHtml(ui.generatedLabel) + '</div>' +
        '<div class="wc-email-adaptive-progress-bar"><span style="width:' + escapeAttributeValue(formatProgressWidth(ui.generatedCount, ui.totalCount)) + '"></span></div>' +
        '<div class="wc-email-adaptive-progress-count">' + escapeHtml(formatInteger(ui.generatedCount)) + '/' + escapeHtml(formatInteger(ui.totalCount)) + ' emails générés</div>' +
      '</section>' +
      renderPreview(ui) +
      '<div class="wc-email-generate-transitions">' +
        '<button type="button" class="wc-email-generate-transition wc-email-adaptive-confirm" data-email-adaptive-confirm="true"' + (ui.confirmAction.enabled ? '' : ' disabled') + '>' + renderLucideIcon('send') + '<span>' + escapeHtml(ui.confirmAction.label) + '</span></button>' +
        '<button type="button" class="wc-email-generate-transition wc-email-adaptive-cancel" data-email-adaptive-cancel="true">' + renderLucideIcon('fileText') + '<span>' + escapeHtml(ui.cancelAction.label) + '</span></button>' +
      '</div>' +
    '</div>'
  )
}

function bindEmailAdaptiveEstimateUi(el, ui, handlers) {
  if (!el || !ui) return
  var recipientButton = el.querySelector('[data-email-adaptive-recipients="true"]')
  var recipientHost = el.querySelector('[data-email-adaptive-recipient-popin-host]')
  bindRecipientPopin(el, ui, handlers)
  if (recipientButton && recipientHost) {
    recipientButton.addEventListener('click', function () {
      recipientHost.removeAttribute('hidden')
      if (handlers && typeof handlers.onRecipientPage === 'function') {
        handlers.onRecipientPage({
          action: 'listRecipients',
          estimateId: ui.confirmAction.estimateId,
          page: ui.recipientManager.page
        }, {
          replace: function (nextUi) {
            replaceRecipientPopin(el, nextUi, handlers)
          }
        })
      }
    })
  }

  var confirmButton = el.querySelector('[data-email-adaptive-confirm="true"]')
  if (confirmButton && ui.confirmAction.enabled) {
    confirmButton.addEventListener('click', function () {
      if (handlers && typeof handlers.onConfirm === 'function') {
        handlers.onConfirm({
          action: 'confirm',
          estimateId: ui.confirmAction.estimateId,
          label: ui.confirmAction.label
        })
      }
    })
  }

  var cancelButton = el.querySelector('[data-email-adaptive-cancel="true"]')
  if (cancelButton) {
    cancelButton.addEventListener('click', function () {
      if (handlers && typeof handlers.onCancel === 'function') {
        handlers.onCancel({
          action: 'cancel',
          target: ui.cancelAction.target,
          label: ui.cancelAction.label
        })
      }
    })
  }
}

function renderPreview(ui) {
  return (
    '<section class="wc-email-generate-preview">' +
      '<div class="wc-email-generate-section-label">' + escapeHtml(ui.previewLabel) + '</div>' +
      '<div class="wc-email-generate-preview-row"><span class="wc-email-generate-preview-key">A</span><span class="wc-email-generate-preview-value">' + escapeHtml(ui.preview.to || '') + '</span></div>' +
      '<div class="wc-email-generate-preview-row"><span class="wc-email-generate-preview-key">Objet</span><span class="wc-email-generate-preview-value">' + escapeHtml(ui.preview.subject || '') + '</span></div>' +
      '<div class="wc-email-generate-section-label">Corps de l\'email</div>' +
      '<div class="wc-email-generate-preview-body">' + renderMultiline(ui.preview.body || '') + '</div>' +
    '</section>'
  )
}

function renderRecipientPopin(ui) {
  var manager = ui.recipientManager
  return renderPopin({
    className: 'wc-email-adaptive-recipient-popin',
    dialogClassName: 'wc-email-adaptive-recipient-dialog',
    title: manager.label || 'Destinataires',
    ariaLabel: manager.label || 'Destinataires',
    closeAttributes: 'data-popin-close data-email-adaptive-recipient-close',
    header: '<div><h3>' + escapeHtml(manager.label || 'Destinataires') + '</h3><p>' + escapeHtml(manager.hint || '') + '</p></div>',
    body:
      '<div class="wc-email-adaptive-recipient-list" data-email-adaptive-recipient-list>' +
        renderRecipientItems(manager) +
      '</div>' +
      '<div class="wc-email-adaptive-recipient-pagination">' +
        '<button type="button" data-email-adaptive-recipient-page="' + escapeAttributeValue(String(Math.max(1, manager.page - 1))) + '"' + (manager.page <= 1 ? ' disabled' : '') + '>' + renderLucideIcon('chevronLeft') + '<span>Précédent</span></button>' +
        '<strong>' + escapeHtml(formatInteger(manager.page)) + '/' + escapeHtml(formatInteger(manager.totalPages)) + '</strong>' +
        '<button type="button" data-email-adaptive-recipient-page="' + escapeAttributeValue(String(Math.min(manager.totalPages, manager.page + 1))) + '"' + (manager.page >= manager.totalPages ? ' disabled' : '') + '><span>Suivant</span>' + renderLucideIcon('chevronRight') + '</button>' +
      '</div>'
  })
}

function renderRecipientItems(manager) {
  if (!manager.items.length) {
    return '<div class="wc-email-adaptive-recipient-empty">Aucun destinataire sélectionné.</div>'
  }

  return manager.items.map(function (item) {
    var meta = [item.email, item.sourceLabel].filter(Boolean).join(' · ')
    var statusChip = item.status === 'no_optin'
      ? '<span class="wc-email-adaptive-recipient-chip warning">' + escapeHtml(item.statusLabel || 'Non optin') + '</span>'
      : ''
    return (
      '<div class="wc-email-adaptive-recipient-item" data-email-adaptive-recipient-key="' + escapeAttributeValue(item.key) + '">' +
        '<div class="wc-email-adaptive-recipient-copy">' +
          '<div class="wc-email-adaptive-recipient-title"><strong>' + escapeHtml(item.label || item.email || 'Destinataire') + '</strong>' + statusChip + '</div>' +
          '<span>' + escapeHtml(meta) + '</span>' +
        '</div>' +
        '<button type="button" class="wc-email-adaptive-recipient-remove" data-email-adaptive-recipient-remove="' + escapeAttributeValue(item.key) + '" aria-label="Ecarter ce destinataire">' + renderLucideIcon('trash2') + '</button>' +
      '</div>'
    )
  }).join('')
}

function bindRecipientPopin(el, ui, handlers) {
  var recipientHost = el.querySelector('[data-email-adaptive-recipient-popin-host]')
  if (!recipientHost) return

  Array.prototype.slice.call(recipientHost.querySelectorAll('[data-email-adaptive-recipient-close]')).forEach(function (button) {
    button.addEventListener('click', function () {
      recipientHost.setAttribute('hidden', 'hidden')
    })
  })

  Array.prototype.slice.call(recipientHost.querySelectorAll('[data-email-adaptive-recipient-page]')).forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled || !handlers || typeof handlers.onRecipientPage !== 'function') return
      handlers.onRecipientPage({
        action: 'listRecipients',
        estimateId: ui.confirmAction.estimateId,
        page: normalizeCount(button.getAttribute('data-email-adaptive-recipient-page')) || 1
      }, {
        replace: function (nextUi) {
          replaceRecipientPopin(el, nextUi, handlers)
        }
      })
    })
  })

  Array.prototype.slice.call(recipientHost.querySelectorAll('[data-email-adaptive-recipient-remove]')).forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled || !handlers || typeof handlers.onRecipientExclude !== 'function') return
      button.disabled = true
      handlers.onRecipientExclude({
        action: 'excludeRecipient',
        estimateId: ui.confirmAction.estimateId,
        page: ui.recipientManager.page,
        recipientKey: String(button.getAttribute('data-email-adaptive-recipient-remove') || '')
      }, {
        replace: function (nextUi) {
          replaceAdaptiveEstimate(el, nextUi, handlers)
        },
        restore: function () {
          button.disabled = false
        }
      })
    })
  })
}

function replaceRecipientPopin(el, nextUi, handlers) {
  if (!nextUi) return
  var recipientHost = el.querySelector('[data-email-adaptive-recipient-popin-host]')
  if (!recipientHost) return
  recipientHost.innerHTML = renderRecipientPopin(nextUi)
  recipientHost.removeAttribute('hidden')
  bindRecipientPopin(el, nextUi, handlers)
}

function replaceAdaptiveEstimate(el, nextUi, handlers) {
  if (!nextUi) return
  el.innerHTML = renderEmailAdaptiveEstimateUi(nextUi)
  bindEmailAdaptiveEstimateUi(el, nextUi, handlers)
  var recipientHost = el.querySelector('[data-email-adaptive-recipient-popin-host]')
  if (recipientHost) recipientHost.removeAttribute('hidden')
}

function normalizeRecipientManager(value) {
  var manager = value && typeof value === 'object' ? value : {}
  var items = Array.isArray(manager.items) ? manager.items : []
  var pageSize = normalizeCount(manager.pageSize) || 40
  var total = normalizeCount(manager.total)
  var totalPages = Math.max(1, normalizeCount(manager.totalPages) || Math.ceil(total / pageSize) || 1)
  var page = Math.max(1, Math.min(totalPages, normalizeCount(manager.page) || 1))

  return {
    label: String(manager.label || 'Destinataires'),
    hint: String(manager.hint || 'Cliquer pour consulter et/ou écarter des destinataires'),
    page: page,
    pageSize: pageSize,
    total: total,
    totalPages: totalPages,
    items: items.map(function (item) {
      item = item && typeof item === 'object' ? item : {}
      return {
        key: String(item.key || '').trim(),
        label: String(item.label || '').trim(),
        email: item.email === null || item.email === undefined ? null : String(item.email || '').trim(),
        sourceLabel: item.sourceLabel === null || item.sourceLabel === undefined ? null : String(item.sourceLabel || '').trim(),
        sourceObjectType: String(item.sourceObjectType || '').trim(),
        status: String(item.status || '').trim(),
        statusLabel: String(item.statusLabel || '').trim()
      }
    }).filter(function (item) {
      return item.key
    })
  }
}

function normalizeCount(value) {
  var numeric = Number(value)
  return Number.isFinite(numeric) && numeric >= 0 ? Math.floor(numeric) : 0
}

function normalizeNullableAmount(value) {
  if (value === null || value === undefined || value === '') return null
  var numeric = Number(value)
  return Number.isFinite(numeric) && numeric >= 0
    ? Math.round((numeric + Number.EPSILON) * 1000000) / 1000000
    : null
}

function formatInteger(value) {
  return new Intl.NumberFormat('fr-FR').format(Math.max(0, Math.floor(Number(value) || 0)))
}

function formatCredits(value) {
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(Math.max(0, Number(value) || 0))
}

function formatProgressWidth(value, total) {
  if (!total) return '0%'
  return Math.max(0, Math.min(100, Math.round((value / total) * 100))) + '%'
}

function renderMultiline(value) {
  return escapeHtml(String(value || '')).replace(/\n/g, '<br>')
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeAttributeValue(value) {
  return escapeHtml(value).replace(/`/g, '&#96;')
}

export {
  bindEmailAdaptiveEstimateUi,
  normalizeEmailAdaptiveEstimateUi,
  renderEmailAdaptiveEstimateUi
}
